<template>
  <Modal v-model="supplierOrdersLogModal" :title="$t('key1002478')" width="700" :transfer="false" @on-visible-change="dailyRecordChange">
    <h2 class="mb10">{{ packageCode + $t('key1003131') }}</h2>
    <div class="table_box">
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <template #footer>
      <div style="text-align: right;">
        <Button type="primary" @click="supplierOrdersLogModal = false">{{ $t('key1000316') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {getAllUsersInfo, getUserNameByUserId} from "@/utils/common";

export default {
  name: "supplierOrdersLogModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      supplierOrdersLogModal: false,
      tableColumns: [
        {
          key: 'logContentDesc',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000290'), // 操作内容描述
          minWidth: 300,
          render(h, params) {
            return h('span', params.row.logContentDesc);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          minWidth: 150,
          key: 'updatedBy',
          align: 'center',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.updatedBy, v.userInfoList, v.$route.path));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000291'),
          key: 'updatedTime',
          align: 'center',
          sortable: true,
          sortType: 'desc',
          minWidth: 180,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.updatedTime, 'fulltime'));
          }
        },
      ],
      tableData: [],
      packageCode: null,
      userInfoList:{}
    };
  },
  methods: {
    // 初始化数据
    initsupplierOrdersLogData(data) {
      let v = this;
      v.packageCode = data.subPackageCode;
      v.tableData = [];
      (async () => {
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.getLogData(data.ymsSubPackageId);
      })();
    },
    // 获取操作日志的数据
    getLogData(ymsSubPackageId) {
      let v = this;
      v.tableLoading = true;
      v.axios.get(api.get_ymsSubPackageInfo_querySupplierLog + ymsSubPackageId).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          v.tableData = data;
          v.supplierOrdersLogModal = true;
        }
      });
    },
    // 监听弹窗
    dailyRecordChange(value) {
      if (!value) {
        this.tableData = [];
        this.packageCode = null;
      }
    }
  }
};
</script>

<style scoped>

</style>